const manageStatus = {
  state: {
    vantTabsStatus: null, // 评课专家分配页面tab状态
    selectExpertsList: [] // 选择专家后保存
  },

  mutations: {
    SET_TABS_STATUS: (state, data) => {
      state.vantTabsStatus = data;
    },
    SET_SELECT_EXPERTS_LIST: (state, data) => {
      state.selectExpertsList = data;
    }
  },

  actions: {
  }
};

export default manageStatus;

